// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as publicRouteRouteImport } from './routes/(public)/route'
import { Route as portalRouteRouteImport } from './routes/(portal)/route'
import { Route as onboardingRouteRouteImport } from './routes/(onboarding)/route'
import { Route as connectRouteRouteImport } from './routes/(connect)/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as appRouteRouteImport } from './routes/(app)/route'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as publicYoutubeSchedulerRouteImport } from './routes/(public)/youtube-scheduler'
import { Route as publicTwitterSchedulerRouteImport } from './routes/(public)/twitter-scheduler'
import { Route as publicTiktokSchedulerRouteImport } from './routes/(public)/tiktok-scheduler'
import { Route as publicThreadsSchedulerRouteImport } from './routes/(public)/threads-scheduler'
import { Route as publicTermsRouteImport } from './routes/(public)/terms'
import { Route as publicSuccessRouteImport } from './routes/(public)/success'
import { Route as publicSignupRouteImport } from './routes/(public)/signup'
import { Route as publicSignUpRouteImport } from './routes/(public)/sign-up'
import { Route as publicRegisterRouteImport } from './routes/(public)/register'
import { Route as publicPrivacyRouteImport } from './routes/(public)/privacy'
import { Route as publicPricingRouteImport } from './routes/(public)/pricing'
import { Route as publicPinterestSchedulerRouteImport } from './routes/(public)/pinterest-scheduler'
import { Route as publicMastodonSchedulerRouteImport } from './routes/(public)/mastodon-scheduler'
import { Route as publicLinkedinSchedulerRouteImport } from './routes/(public)/linkedin-scheduler'
import { Route as publicIntegrationsRouteImport } from './routes/(public)/integrations'
import { Route as publicInstagramSchedulerRouteImport } from './routes/(public)/instagram-scheduler'
import { Route as publicGdprRouteImport } from './routes/(public)/gdpr'
import { Route as publicFeaturesRouteImport } from './routes/(public)/features'
import { Route as publicFacebookSchedulerRouteImport } from './routes/(public)/facebook-scheduler'
import { Route as publicDataDeletionRouteImport } from './routes/(public)/data-deletion'
import { Route as publicCookiePolicyRouteImport } from './routes/(public)/cookie-policy'
import { Route as publicContactRouteImport } from './routes/(public)/contact'
import { Route as publicClientApprovalsRouteImport } from './routes/(public)/client-approvals'
import { Route as publicChangelogRouteImport } from './routes/(public)/changelog'
import { Route as publicCareersRouteImport } from './routes/(public)/careers'
import { Route as publicBlueskySchedulerRouteImport } from './routes/(public)/bluesky-scheduler'
import { Route as publicAiAgentsRouteImport } from './routes/(public)/ai-agents'
import { Route as publicAboutRouteImport } from './routes/(public)/about'
import { Route as onboardingOnboardingRouteImport } from './routes/(onboarding)/onboarding'
import { Route as connectAuthorizeRouteImport } from './routes/(connect)/authorize'
import { Route as authTwoFactorRouteImport } from './routes/(auth)/two-factor'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as appSettingsRouteImport } from './routes/(app)/settings'
import { Route as appQueueRouteImport } from './routes/(app)/queue'
import { Route as appPostsRouteImport } from './routes/(app)/posts'
import { Route as appMediaRouteImport } from './routes/(app)/media'
import { Route as appDashboardRouteImport } from './routes/(app)/dashboard'
import { Route as appChannelsRouteImport } from './routes/(app)/channels'
import { Route as appCalendarRouteImport } from './routes/(app)/calendar'
import { Route as appBulkRouteImport } from './routes/(app)/bulk'
import { Route as appAnalyticsRouteImport } from './routes/(app)/analytics'
import { Route as appAcceptInviteRouteImport } from './routes/(app)/accept-invite'
import { Route as publicToolsIndexRouteImport } from './routes/(public)/tools.index'
import { Route as publicPartnersIndexRouteImport } from './routes/(public)/partners.index'
import { Route as publicLimitsIndexRouteImport } from './routes/(public)/limits.index'
import { Route as publicHelpIndexRouteImport } from './routes/(public)/help.index'
import { Route as publicBlogIndexRouteImport } from './routes/(public)/blog.index'
import { Route as publicAlternativesIndexRouteImport } from './routes/(public)/alternatives.index'
import { Route as publicToolsVideoCheckerRouteImport } from './routes/(public)/tools.video-checker'
import { Route as publicToolsThreadSplitterRouteImport } from './routes/(public)/tools.thread-splitter'
import { Route as publicToolsMastodonLimitsRouteImport } from './routes/(public)/tools.mastodon-limits'
import { Route as publicToolsMastodonBestTimeRouteImport } from './routes/(public)/tools.mastodon-best-time'
import { Route as publicToolsContentCalendar2027RouteImport } from './routes/(public)/tools.content-calendar-2027'
import { Route as publicToolsCharacterCounterRouteImport } from './routes/(public)/tools.character-counter'
import { Route as publicToolsBulkCsvCheckerRouteImport } from './routes/(public)/tools.bulk-csv-checker'
import { Route as publicToolsBlueskyEngagementRateRouteImport } from './routes/(public)/tools.bluesky-engagement-rate'
import { Route as publicToolsBlueskyBestTimeRouteImport } from './routes/(public)/tools.bluesky-best-time'
import { Route as publicRCodeRouteImport } from './routes/(public)/r.$code'
import { Route as publicPartnersTermsRouteImport } from './routes/(public)/partners.terms'
import { Route as publicPartnersApplyRouteImport } from './routes/(public)/partners.apply'
import { Route as publicLimitsNetworkRouteImport } from './routes/(public)/limits.$network'
import { Route as publicHelpSlugRouteImport } from './routes/(public)/help.$slug'
import { Route as publicBlogSlugRouteImport } from './routes/(public)/blog.$slug'
import { Route as publicAlternativesCompetitorRouteImport } from './routes/(public)/alternatives.$competitor'
import { Route as portalReviewTokenRouteImport } from './routes/(portal)/review.$token'
import { Route as portalCreatorTokenRouteImport } from './routes/(portal)/creator.$token'
import { Route as appSettingsSocialAccountsRouteImport } from './routes/(app)/settings.social-accounts'
import { Route as appSettingsSecurityRouteImport } from './routes/(app)/settings.security'
import { Route as appSettingsProfileRouteImport } from './routes/(app)/settings.profile'
import { Route as appSettingsNotificationsRouteImport } from './routes/(app)/settings.notifications'
import { Route as appSettingsMembersRouteImport } from './routes/(app)/settings.members'
import { Route as appSettingsBillingRouteImport } from './routes/(app)/settings.billing'
import { Route as appSettingsAuditRouteImport } from './routes/(app)/settings.audit'
import { Route as appSettingsApprovalsRouteImport } from './routes/(app)/settings.approvals'
import { Route as appSettingsAiRouteImport } from './routes/(app)/settings.ai'
import { Route as appSettingsAgentsRouteImport } from './routes/(app)/settings.agents'
import { Route as appSettingsAccountRouteImport } from './routes/(app)/settings.account'
import { Route as appPostsPostIdRouteImport } from './routes/(app)/posts.$postId'
import { Route as appChannelsIndexRouteImport } from './routes/(app)/channels.index'
import { Route as appChannelsConnectRouteImport } from './routes/(app)/channels.connect'
import { Route as appChannelsIdRouteImport } from './routes/(app)/channels.$id'
import { Route as appCalendarIndexRouteImport } from './routes/(app)/calendar.index'
import { Route as appCalendarViewRouteImport } from './routes/(app)/calendar.$view'
import { Route as appChannelsIdIndexRouteImport } from './routes/(app)/channels.$id.index'
import { Route as appChannelsIdSettingsRouteImport } from './routes/(app)/channels.$id.settings'
import { Route as appChannelsIdPublishRouteImport } from './routes/(app)/channels.$id.publish'
import { Route as appChannelsIdAnalyticsRouteImport } from './routes/(app)/channels.$id.analytics'

const publicRouteRoute = publicRouteRouteImport.update({
            id: '/(public)',getParentRoute: () => rootRouteImport
          })
const portalRouteRoute = portalRouteRouteImport.update({
            id: '/(portal)',getParentRoute: () => rootRouteImport
          })
const onboardingRouteRoute = onboardingRouteRouteImport.update({
            id: '/(onboarding)',getParentRoute: () => rootRouteImport
          })
const connectRouteRoute = connectRouteRouteImport.update({
            id: '/(connect)',getParentRoute: () => rootRouteImport
          })
const authRouteRoute = authRouteRouteImport.update({
            id: '/(auth)',getParentRoute: () => rootRouteImport
          })
const appRouteRoute = appRouteRouteImport.update({
            id: '/(app)',getParentRoute: () => rootRouteImport
          })
const publicIndexRoute = publicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => publicRouteRoute
          })
const publicYoutubeSchedulerRoute = publicYoutubeSchedulerRouteImport.update({
            id: '/youtube-scheduler',path: '/youtube-scheduler',getParentRoute: () => publicRouteRoute
          })
const publicTwitterSchedulerRoute = publicTwitterSchedulerRouteImport.update({
            id: '/twitter-scheduler',path: '/twitter-scheduler',getParentRoute: () => publicRouteRoute
          })
const publicTiktokSchedulerRoute = publicTiktokSchedulerRouteImport.update({
            id: '/tiktok-scheduler',path: '/tiktok-scheduler',getParentRoute: () => publicRouteRoute
          })
const publicThreadsSchedulerRoute = publicThreadsSchedulerRouteImport.update({
            id: '/threads-scheduler',path: '/threads-scheduler',getParentRoute: () => publicRouteRoute
          })
const publicTermsRoute = publicTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => publicRouteRoute
          })
const publicSuccessRoute = publicSuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => publicRouteRoute
          })
const publicSignupRoute = publicSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => publicRouteRoute
          })
const publicSignUpRoute = publicSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => publicRouteRoute
          })
const publicRegisterRoute = publicRegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => publicRouteRoute
          })
const publicPrivacyRoute = publicPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => publicRouteRoute
          })
const publicPricingRoute = publicPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => publicRouteRoute
          })
const publicPinterestSchedulerRoute = publicPinterestSchedulerRouteImport.update({
            id: '/pinterest-scheduler',path: '/pinterest-scheduler',getParentRoute: () => publicRouteRoute
          })
const publicMastodonSchedulerRoute = publicMastodonSchedulerRouteImport.update({
            id: '/mastodon-scheduler',path: '/mastodon-scheduler',getParentRoute: () => publicRouteRoute
          })
const publicLinkedinSchedulerRoute = publicLinkedinSchedulerRouteImport.update({
            id: '/linkedin-scheduler',path: '/linkedin-scheduler',getParentRoute: () => publicRouteRoute
          })
const publicIntegrationsRoute = publicIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => publicRouteRoute
          })
const publicInstagramSchedulerRoute = publicInstagramSchedulerRouteImport.update({
            id: '/instagram-scheduler',path: '/instagram-scheduler',getParentRoute: () => publicRouteRoute
          })
const publicGdprRoute = publicGdprRouteImport.update({
            id: '/gdpr',path: '/gdpr',getParentRoute: () => publicRouteRoute
          })
const publicFeaturesRoute = publicFeaturesRouteImport.update({
            id: '/features',path: '/features',getParentRoute: () => publicRouteRoute
          })
const publicFacebookSchedulerRoute = publicFacebookSchedulerRouteImport.update({
            id: '/facebook-scheduler',path: '/facebook-scheduler',getParentRoute: () => publicRouteRoute
          })
const publicDataDeletionRoute = publicDataDeletionRouteImport.update({
            id: '/data-deletion',path: '/data-deletion',getParentRoute: () => publicRouteRoute
          })
const publicCookiePolicyRoute = publicCookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => publicRouteRoute
          })
const publicContactRoute = publicContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => publicRouteRoute
          })
const publicClientApprovalsRoute = publicClientApprovalsRouteImport.update({
            id: '/client-approvals',path: '/client-approvals',getParentRoute: () => publicRouteRoute
          })
const publicChangelogRoute = publicChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => publicRouteRoute
          })
const publicCareersRoute = publicCareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => publicRouteRoute
          })
const publicBlueskySchedulerRoute = publicBlueskySchedulerRouteImport.update({
            id: '/bluesky-scheduler',path: '/bluesky-scheduler',getParentRoute: () => publicRouteRoute
          })
const publicAiAgentsRoute = publicAiAgentsRouteImport.update({
            id: '/ai-agents',path: '/ai-agents',getParentRoute: () => publicRouteRoute
          })
const publicAboutRoute = publicAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => publicRouteRoute
          })
const onboardingOnboardingRoute = onboardingOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => onboardingRouteRoute
          })
const connectAuthorizeRoute = connectAuthorizeRouteImport.update({
            id: '/authorize',path: '/authorize',getParentRoute: () => connectRouteRoute
          })
const authTwoFactorRoute = authTwoFactorRouteImport.update({
            id: '/two-factor',path: '/two-factor',getParentRoute: () => authRouteRoute
          })
const authResetPasswordRoute = authResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => authRouteRoute
          })
const authLoginRoute = authLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => authRouteRoute
          })
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => authRouteRoute
          })
const appSettingsRoute = appSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => appRouteRoute
          })
const appQueueRoute = appQueueRouteImport.update({
            id: '/queue',path: '/queue',getParentRoute: () => appRouteRoute
          })
const appPostsRoute = appPostsRouteImport.update({
            id: '/posts',path: '/posts',getParentRoute: () => appRouteRoute
          })
const appMediaRoute = appMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => appRouteRoute
          })
const appDashboardRoute = appDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => appRouteRoute
          })
const appChannelsRoute = appChannelsRouteImport.update({
            id: '/channels',path: '/channels',getParentRoute: () => appRouteRoute
          })
const appCalendarRoute = appCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => appRouteRoute
          })
const appBulkRoute = appBulkRouteImport.update({
            id: '/bulk',path: '/bulk',getParentRoute: () => appRouteRoute
          })
const appAnalyticsRoute = appAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => appRouteRoute
          })
const appAcceptInviteRoute = appAcceptInviteRouteImport.update({
            id: '/accept-invite',path: '/accept-invite',getParentRoute: () => appRouteRoute
          })
const publicToolsIndexRoute = publicToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => publicRouteRoute
          })
const publicPartnersIndexRoute = publicPartnersIndexRouteImport.update({
            id: '/partners/',path: '/partners/',getParentRoute: () => publicRouteRoute
          })
const publicLimitsIndexRoute = publicLimitsIndexRouteImport.update({
            id: '/limits/',path: '/limits/',getParentRoute: () => publicRouteRoute
          })
const publicHelpIndexRoute = publicHelpIndexRouteImport.update({
            id: '/help/',path: '/help/',getParentRoute: () => publicRouteRoute
          })
const publicBlogIndexRoute = publicBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => publicRouteRoute
          })
const publicAlternativesIndexRoute = publicAlternativesIndexRouteImport.update({
            id: '/alternatives/',path: '/alternatives/',getParentRoute: () => publicRouteRoute
          })
const publicToolsVideoCheckerRoute = publicToolsVideoCheckerRouteImport.update({
            id: '/tools/video-checker',path: '/tools/video-checker',getParentRoute: () => publicRouteRoute
          })
const publicToolsThreadSplitterRoute = publicToolsThreadSplitterRouteImport.update({
            id: '/tools/thread-splitter',path: '/tools/thread-splitter',getParentRoute: () => publicRouteRoute
          })
const publicToolsMastodonLimitsRoute = publicToolsMastodonLimitsRouteImport.update({
            id: '/tools/mastodon-limits',path: '/tools/mastodon-limits',getParentRoute: () => publicRouteRoute
          })
const publicToolsMastodonBestTimeRoute = publicToolsMastodonBestTimeRouteImport.update({
            id: '/tools/mastodon-best-time',path: '/tools/mastodon-best-time',getParentRoute: () => publicRouteRoute
          })
const publicToolsContentCalendar2027Route = publicToolsContentCalendar2027RouteImport.update({
            id: '/tools/content-calendar-2027',path: '/tools/content-calendar-2027',getParentRoute: () => publicRouteRoute
          })
const publicToolsCharacterCounterRoute = publicToolsCharacterCounterRouteImport.update({
            id: '/tools/character-counter',path: '/tools/character-counter',getParentRoute: () => publicRouteRoute
          })
const publicToolsBulkCsvCheckerRoute = publicToolsBulkCsvCheckerRouteImport.update({
            id: '/tools/bulk-csv-checker',path: '/tools/bulk-csv-checker',getParentRoute: () => publicRouteRoute
          })
const publicToolsBlueskyEngagementRateRoute = publicToolsBlueskyEngagementRateRouteImport.update({
            id: '/tools/bluesky-engagement-rate',path: '/tools/bluesky-engagement-rate',getParentRoute: () => publicRouteRoute
          })
const publicToolsBlueskyBestTimeRoute = publicToolsBlueskyBestTimeRouteImport.update({
            id: '/tools/bluesky-best-time',path: '/tools/bluesky-best-time',getParentRoute: () => publicRouteRoute
          })
const publicRCodeRoute = publicRCodeRouteImport.update({
            id: '/r/$code',path: '/r/$code',getParentRoute: () => publicRouteRoute
          })
const publicPartnersTermsRoute = publicPartnersTermsRouteImport.update({
            id: '/partners/terms',path: '/partners/terms',getParentRoute: () => publicRouteRoute
          })
const publicPartnersApplyRoute = publicPartnersApplyRouteImport.update({
            id: '/partners/apply',path: '/partners/apply',getParentRoute: () => publicRouteRoute
          })
const publicLimitsNetworkRoute = publicLimitsNetworkRouteImport.update({
            id: '/limits/$network',path: '/limits/$network',getParentRoute: () => publicRouteRoute
          })
const publicHelpSlugRoute = publicHelpSlugRouteImport.update({
            id: '/help/$slug',path: '/help/$slug',getParentRoute: () => publicRouteRoute
          })
const publicBlogSlugRoute = publicBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => publicRouteRoute
          })
const publicAlternativesCompetitorRoute = publicAlternativesCompetitorRouteImport.update({
            id: '/alternatives/$competitor',path: '/alternatives/$competitor',getParentRoute: () => publicRouteRoute
          })
const portalReviewTokenRoute = portalReviewTokenRouteImport.update({
            id: '/review/$token',path: '/review/$token',getParentRoute: () => portalRouteRoute
          })
const portalCreatorTokenRoute = portalCreatorTokenRouteImport.update({
            id: '/creator/$token',path: '/creator/$token',getParentRoute: () => portalRouteRoute
          })
const appSettingsSocialAccountsRoute = appSettingsSocialAccountsRouteImport.update({
            id: '/social-accounts',path: '/social-accounts',getParentRoute: () => appSettingsRoute
          })
const appSettingsSecurityRoute = appSettingsSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => appSettingsRoute
          })
const appSettingsProfileRoute = appSettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => appSettingsRoute
          })
const appSettingsNotificationsRoute = appSettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => appSettingsRoute
          })
const appSettingsMembersRoute = appSettingsMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => appSettingsRoute
          })
const appSettingsBillingRoute = appSettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => appSettingsRoute
          })
const appSettingsAuditRoute = appSettingsAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => appSettingsRoute
          })
const appSettingsApprovalsRoute = appSettingsApprovalsRouteImport.update({
            id: '/approvals',path: '/approvals',getParentRoute: () => appSettingsRoute
          })
const appSettingsAiRoute = appSettingsAiRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => appSettingsRoute
          })
const appSettingsAgentsRoute = appSettingsAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => appSettingsRoute
          })
const appSettingsAccountRoute = appSettingsAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => appSettingsRoute
          })
const appPostsPostIdRoute = appPostsPostIdRouteImport.update({
            id: '/$postId',path: '/$postId',getParentRoute: () => appPostsRoute
          })
const appChannelsIndexRoute = appChannelsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => appChannelsRoute
          })
const appChannelsConnectRoute = appChannelsConnectRouteImport.update({
            id: '/connect',path: '/connect',getParentRoute: () => appChannelsRoute
          })
const appChannelsIdRoute = appChannelsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => appChannelsRoute
          })
const appCalendarIndexRoute = appCalendarIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => appCalendarRoute
          })
const appCalendarViewRoute = appCalendarViewRouteImport.update({
            id: '/$view',path: '/$view',getParentRoute: () => appCalendarRoute
          })
const appChannelsIdIndexRoute = appChannelsIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => appChannelsIdRoute
          })
const appChannelsIdSettingsRoute = appChannelsIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => appChannelsIdRoute
          })
const appChannelsIdPublishRoute = appChannelsIdPublishRouteImport.update({
            id: '/publish',path: '/publish',getParentRoute: () => appChannelsIdRoute
          })
const appChannelsIdAnalyticsRoute = appChannelsIdAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => appChannelsIdRoute
          })





const appCalendarRouteChildren = {
  appCalendarViewRoute: appCalendarViewRoute,appCalendarIndexRoute: appCalendarIndexRoute
}

const appCalendarRouteWithChildren = appCalendarRoute._addFileChildren(appCalendarRouteChildren)




const appChannelsIdRouteChildren = {
  appChannelsIdAnalyticsRoute: appChannelsIdAnalyticsRoute,appChannelsIdPublishRoute: appChannelsIdPublishRoute,appChannelsIdSettingsRoute: appChannelsIdSettingsRoute,appChannelsIdIndexRoute: appChannelsIdIndexRoute
}

const appChannelsIdRouteWithChildren = appChannelsIdRoute._addFileChildren(appChannelsIdRouteChildren)



const appChannelsRouteChildren = {
  appChannelsIdRoute: appChannelsIdRouteWithChildren,appChannelsConnectRoute: appChannelsConnectRoute,appChannelsIndexRoute: appChannelsIndexRoute
}

const appChannelsRouteWithChildren = appChannelsRoute._addFileChildren(appChannelsRouteChildren)




const appPostsRouteChildren = {
  appPostsPostIdRoute: appPostsPostIdRoute
}

const appPostsRouteWithChildren = appPostsRoute._addFileChildren(appPostsRouteChildren)




const appSettingsRouteChildren = {
  appSettingsAccountRoute: appSettingsAccountRoute,appSettingsAgentsRoute: appSettingsAgentsRoute,appSettingsAiRoute: appSettingsAiRoute,appSettingsApprovalsRoute: appSettingsApprovalsRoute,appSettingsAuditRoute: appSettingsAuditRoute,appSettingsBillingRoute: appSettingsBillingRoute,appSettingsMembersRoute: appSettingsMembersRoute,appSettingsNotificationsRoute: appSettingsNotificationsRoute,appSettingsProfileRoute: appSettingsProfileRoute,appSettingsSecurityRoute: appSettingsSecurityRoute,appSettingsSocialAccountsRoute: appSettingsSocialAccountsRoute
}

const appSettingsRouteWithChildren = appSettingsRoute._addFileChildren(appSettingsRouteChildren)



const appRouteRouteChildren = {
  appAcceptInviteRoute: appAcceptInviteRoute,appAnalyticsRoute: appAnalyticsRoute,appBulkRoute: appBulkRoute,appCalendarRoute: appCalendarRouteWithChildren,appChannelsRoute: appChannelsRouteWithChildren,appDashboardRoute: appDashboardRoute,appMediaRoute: appMediaRoute,appPostsRoute: appPostsRouteWithChildren,appQueueRoute: appQueueRoute,appSettingsRoute: appSettingsRouteWithChildren
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(appRouteRouteChildren)




const authRouteRouteChildren = {
  authForgotPasswordRoute: authForgotPasswordRoute,authLoginRoute: authLoginRoute,authResetPasswordRoute: authResetPasswordRoute,authTwoFactorRoute: authTwoFactorRoute
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(authRouteRouteChildren)




const connectRouteRouteChildren = {
  connectAuthorizeRoute: connectAuthorizeRoute
}

const connectRouteRouteWithChildren = connectRouteRoute._addFileChildren(connectRouteRouteChildren)




const onboardingRouteRouteChildren = {
  onboardingOnboardingRoute: onboardingOnboardingRoute
}

const onboardingRouteRouteWithChildren = onboardingRouteRoute._addFileChildren(onboardingRouteRouteChildren)




const portalRouteRouteChildren = {
  portalCreatorTokenRoute: portalCreatorTokenRoute,portalReviewTokenRoute: portalReviewTokenRoute
}

const portalRouteRouteWithChildren = portalRouteRoute._addFileChildren(portalRouteRouteChildren)




const publicRouteRouteChildren = {
  publicAboutRoute: publicAboutRoute,publicAiAgentsRoute: publicAiAgentsRoute,publicBlueskySchedulerRoute: publicBlueskySchedulerRoute,publicCareersRoute: publicCareersRoute,publicChangelogRoute: publicChangelogRoute,publicClientApprovalsRoute: publicClientApprovalsRoute,publicContactRoute: publicContactRoute,publicCookiePolicyRoute: publicCookiePolicyRoute,publicDataDeletionRoute: publicDataDeletionRoute,publicFacebookSchedulerRoute: publicFacebookSchedulerRoute,publicFeaturesRoute: publicFeaturesRoute,publicGdprRoute: publicGdprRoute,publicInstagramSchedulerRoute: publicInstagramSchedulerRoute,publicIntegrationsRoute: publicIntegrationsRoute,publicLinkedinSchedulerRoute: publicLinkedinSchedulerRoute,publicMastodonSchedulerRoute: publicMastodonSchedulerRoute,publicPinterestSchedulerRoute: publicPinterestSchedulerRoute,publicPricingRoute: publicPricingRoute,publicPrivacyRoute: publicPrivacyRoute,publicRegisterRoute: publicRegisterRoute,publicSignUpRoute: publicSignUpRoute,publicSignupRoute: publicSignupRoute,publicSuccessRoute: publicSuccessRoute,publicTermsRoute: publicTermsRoute,publicThreadsSchedulerRoute: publicThreadsSchedulerRoute,publicTiktokSchedulerRoute: publicTiktokSchedulerRoute,publicTwitterSchedulerRoute: publicTwitterSchedulerRoute,publicYoutubeSchedulerRoute: publicYoutubeSchedulerRoute,publicIndexRoute: publicIndexRoute,publicAlternativesCompetitorRoute: publicAlternativesCompetitorRoute,publicBlogSlugRoute: publicBlogSlugRoute,publicHelpSlugRoute: publicHelpSlugRoute,publicLimitsNetworkRoute: publicLimitsNetworkRoute,publicPartnersApplyRoute: publicPartnersApplyRoute,publicPartnersTermsRoute: publicPartnersTermsRoute,publicRCodeRoute: publicRCodeRoute,publicToolsBlueskyBestTimeRoute: publicToolsBlueskyBestTimeRoute,publicToolsBlueskyEngagementRateRoute: publicToolsBlueskyEngagementRateRoute,publicToolsBulkCsvCheckerRoute: publicToolsBulkCsvCheckerRoute,publicToolsCharacterCounterRoute: publicToolsCharacterCounterRoute,publicToolsContentCalendar2027Route: publicToolsContentCalendar2027Route,publicToolsMastodonBestTimeRoute: publicToolsMastodonBestTimeRoute,publicToolsMastodonLimitsRoute: publicToolsMastodonLimitsRoute,publicToolsThreadSplitterRoute: publicToolsThreadSplitterRoute,publicToolsVideoCheckerRoute: publicToolsVideoCheckerRoute,publicAlternativesIndexRoute: publicAlternativesIndexRoute,publicBlogIndexRoute: publicBlogIndexRoute,publicHelpIndexRoute: publicHelpIndexRoute,publicLimitsIndexRoute: publicLimitsIndexRoute,publicPartnersIndexRoute: publicPartnersIndexRoute,publicToolsIndexRoute: publicToolsIndexRoute
}

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(publicRouteRouteChildren)

const rootRouteChildren = {
  appRouteRoute: appRouteRouteWithChildren,authRouteRoute: authRouteRouteWithChildren,connectRouteRoute: connectRouteRouteWithChildren,onboardingRouteRoute: onboardingRouteRouteWithChildren,portalRouteRoute: portalRouteRouteWithChildren,publicRouteRoute: publicRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)